import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
//===--- Data
import MenuItems from './data/menuItems';

export default function Menu() {
    const renderMenuItems = (category) => {
      return category.map(({ img, title, calories, key }) => (
        <Card key={title} style={{ width: '14rem' }} className='border-0'>
          <a href={`#/menu/product?&item=${key}&other=false`}>
            <Card.Img variant='top' src={img} />
            <Card.Body>
              <Card.Title>{title}</Card.Title>
              <Card.Subtitle className="mb-2 text-muted">{calories}</Card.Subtitle>
            </Card.Body>
          </a>
        </Card>
      ));
    };
    const MilkMenu = renderMenuItems(MenuItems.find(category => category.hasOwnProperty('milkTea')).milkTea);
    const IcedMenu = renderMenuItems(MenuItems.find(category => category.hasOwnProperty('icedTea')).icedTea);
    const HotMenu = renderMenuItems(MenuItems.find(category => category.hasOwnProperty('hotTea')).hotTea);
    const SlushMenu = renderMenuItems(MenuItems.find(category => category.hasOwnProperty('slush')).slush);
    const LunchMenu = renderMenuItems(MenuItems.find(category => category.hasOwnProperty('lunch')).lunch);
    const BreakfastMenu = renderMenuItems(MenuItems.find(category => category.hasOwnProperty('breakfast')).breakfast);
    const BakeryMenu = renderMenuItems(MenuItems.find(category => category.hasOwnProperty('bakery')).bakery);
    function ScrollTo(e) {
      const elem = document.getElementById(e);
      const rect = elem.getBoundingClientRect();
      const yPos = rect.top;
  
  
      window.scrollTo(0, yPos);
    }

    return (
    <section id='menu'>
      <Navbar expand="md" className="bg-body-tertiary fixed-left">
        <Container>
          <Navbar.Toggle aria-controls="basic-navbar-nav" className='border-0' />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Accordion defaultActiveKey="0" className='menu-accord'>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <Navbar.Brand><h5>Drinks</h5></Navbar.Brand>
                  </Accordion.Header>
                  <Accordion.Body>
                    <Nav.Link onClick={()=>(ScrollTo('milk'))}>Milk Tea</Nav.Link>
                    <Nav.Link onClick={()=>(ScrollTo('ice'))}>Iced Tea</Nav.Link>
                    <Nav.Link onClick={()=>(ScrollTo('hot'))}>Hot Tea</Nav.Link>
                    <Nav.Link onClick={()=>(ScrollTo('slush'))}>Slushie</Nav.Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <Navbar.Brand><h5>Food</h5></Navbar.Brand>
                  </Accordion.Header>
                  <Accordion.Body>
                  <Nav.Link onClick={()=>(ScrollTo('lunch'))}>Lunch</Nav.Link>
                  <Nav.Link onClick={()=>(ScrollTo('break'))}>Breakfast</Nav.Link>
                  <Nav.Link onClick={()=>(ScrollTo('bake'))}>Bakery</Nav.Link>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Container className='fixed-right'>
        <h4 id='milk' className='head'>Milk Tea</h4>
        <hr />
        <Container>
         {MilkMenu}
        </Container>
        <h4 id='ice' className='head'>Iced Tea</h4>
        <hr />
        <Container>
         {IcedMenu}
        </Container>
        <h4 id='hot' className='head'>Hot Tea</h4>
        <hr />
        <Container>
         {HotMenu}
        </Container>
        <h4 id='slush' className='head'>Slushie</h4>
        <hr />
        <Container>
         {SlushMenu}
        </Container>
        <h4 id='lunch' className='head'>Lunch</h4>
        <hr />
        <Container>
         {LunchMenu}
        </Container>
        <h4 id='break' className='head'>Breakfast</h4>
        <hr />
        <Container>
         {BreakfastMenu}
        </Container>
        <h4 id='bake' className='head'>Bakery</h4>
        <hr />
        <Container>
         {BakeryMenu}
        </Container>
      </Container>
    </section>
    );
  }